import { useIsomorphicLayoutEffect } from './useIsomorphicLayoutEffect';

let lockCount = 0;
let scrollY = 0;

function acquireBodyLock(): void {
    if (typeof document === 'undefined') {
        lockCount += 1;
        return;
    }

    if (lockCount === 0) {
        scrollY = window.scrollY;
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollY}px`;
        document.body.style.overflow = 'hidden';
    }

    lockCount += 1;
}

function releaseBodyLock(): void {
    if (lockCount === 0) {
        return;
    }

    lockCount -= 1;

    if (typeof document === 'undefined') {
        return;
    }

    if (lockCount === 0) {
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.overflow = '';
        window.scrollTo(0, scrollY);
    }
}

export function useBlockBody(isBlock: boolean): void {
    useIsomorphicLayoutEffect(() => {
        if (!isBlock) {
            return undefined;
        }

        acquireBodyLock();

        return () => {
            releaseBodyLock();
        };
    }, [isBlock]);
}
